import MyTables from './tables.vue'

const Tables = {
  install: function (Vue) {
    Vue.component('Tables', MyTables)
  }
}
export default Tables
